import { BACKGROUND_GRAY_COLOR_NAME, DARK_WORK_OS_IRIS_COLOR_NAME } from "styles/color-consts";

const getParagraphProps = ({ title, body }) => ({
  title,
  body,
  titleColor: DARK_WORK_OS_IRIS_COLOR_NAME,
  topic: {}
});

export default {
  theme: BACKGROUND_GRAY_COLOR_NAME,
  autoplay: true,
  autoplaySpeed: "10000",
  tabs: [
    {
      tabLabel: "Finance",
      tabContent: {
        asset: {
          image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case/Marketing.png",
          }
        },
        images: [
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "Plan and manage budgets effectively",
              body: "See a full breakdown of all cross-department budgets, track costs, and budget allocation in one place."
            })
          },
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "Create and share real-time dashboards",
              body: "With custom dashboards and widgets, view invoices, finance requests, and share data with stakeholders across the organization."
            })
          },
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "Keep track of requests and approvals",
              body: "Create a custom request form to gather and manage all incoming requests and approvals in one board. Get real-time updates on project status, unexpected changes, and more."
            })
          }
        ]
      }
    },
    {
      tabLabel: "Project management",
      tabContent: {
        asset: {
          image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case/Marketing.png",
          }
        },
        images: [
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "Organize objectives with portfolio management",
              body: "Manage projects and programs across multiple teams, and gain a high-level view of your portfolio in one place."
            })
          },
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "Get a full project overview",
              body: "See where projects stand at a glance with Gantt and Kanban views to maximize your workflow."
            })
          },
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "Plan and track projects",
              body: "Bring together deadlines, stakeholders, and budgets in one place. Plan, track, and manage every aspect of your project."
            })
          }
        ],
        banner: {
          productType: "projects",
          badgeText: "new",
          text: "<b>A product built for teams managing advanced projects</b><br>Explore monday projects for exclusive capabilities and integrations",
          buttonText: "Visit monday projects"
        }
      }
    },
    {
      tabLabel: "Marketing workflows",
      tabContent: {
        asset: {
          image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case/Marketing.png",
            alt: "Marketing plan board, Marketing calendar and social media posts"
          }
        },
        images: [
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "Easy campaign management",
              body: "Manage and collaborate on marketing campaigns from planning to execution in one place."
            })
          },
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "Streamline content creation",
              body: "Organize and track progress at a glance to ensure every piece moves through the right stages."
            })
          },
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "Centralized marketing strategy",
              body: "Plan and track business goals, budgets, and marketing campaigns from A-Z."
            })
          }
        ],
        banner: {
          productType: "marketer",
          badgeText: "new",
          text: "<b>A product built for marketing and creative teams</b><br>Explore monday marketer for exclusive capabilities and integrations",
          buttonText: "Visit monday marketer"
        }
      }
    },
    {
      tabLabel: "Creative and design",
      tabContent: {
        asset: {
          image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case/Marketing.png",
          }
        },
        images: [
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "Faster feedback and approvals",
              body: "Manage design files directly within monday.com. Annotate, share files, and collaborate with teams to keep work moving forward."
            })
          },
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "Organize digital assets in one place",
              body: "Manage and collaborate on digital assets, and easily share files with stakeholders and your team in one place."
            })
          },
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "Design team planning",
              body: "Maintain an organized board for your design team. The powerful board lets you stay on top of your iterations easily, whether you are reviewing briefs or organizing files."
            })
          }
        ]
      }
    },
    {
      tabLabel: "IT",
      tabContent: {
        asset: {
          image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case/Marketing.png",
          }
        },
        images: [
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "Visualize service desk performance",
              body: "See the current state of your IT operation at a glance with widget-rich dashboards illustrating SLA, priority, issue types, and more."
            })
          },
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "Auto-assign IT requests",
              body: "With self-service IT request forms, automatically sort incoming employee requests, and assign them to the relevant person."
            })
          },
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "Intuitive service management",
              body: "All requests appear in one place so IT team members can view important details such as the requester’s information, issue type, and uploaded files."
            })
          }
        ]
      }
    },
    {
      tabLabel: "Task management",
      tabContent: {
        asset: {
          image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case/Marketing.png",
          }
        },
        images: [
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "Collaborate on tasks",
              body: "Easily consolidate all task-related information, including files, ideas, and feedback, so you can work together effectively and on time."
            })
          },
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "Turn requests into tasks",
              body: "Automatically turn form submissions into tasks, and assign the right people to them."
            })
          },
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "Track progress from A to Z",
              body: "View dependencies, delegate tasks, priortize, and mark milestones with a Gantt chart."
            })
          }
        ]
      }
    },
    {
      tabLabel: "Operations",
      tabContent: {
        asset: {
          image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case/Marketing.png",
          }
        },
        images: [
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "Manage online and offline events",
              body: "Manage and plan all your events in one place. Track tasks and statuses and make it easy for everyone to collaborate."
            })
          },
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "Streamline facility requests",
              body: "Streamline all facility requests into one place. Create a request form so employees can easily submit requests, stay updated, and more."
            })
          },
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "Spot patterns to keep running smoothly",
              body: "Gain insight into gaps within your organization and improve operations and workflows."
            })
          }
        ]
      }
    },
    {
      tabLabel: "Sales enablement",
      tabContent: {
        asset: {
          image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case/Marketing.png",
          }
        },
        images: [
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "One place for sales enablement",
              body: "Organize and centralize all your sales materials, from case studies to pitch decks. Track new content creation and let sales reps know when they're ready to go."
            })
          },
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "Real-time visibility with custom dashboards",
              body: "Build dashboards that reflect your sales activities without writing a line of code. Get an overview of deal status, team performance, and revenue expectations."
            })
          },
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "Account and lead management made easy",
              body: "Track and organize prospects, accounts, and deals in one place. Manage all lead information to keep the relationship moving forward."
            })
          }
        ],
        banner: {
          productType: "crm",
          badgeText: "new",
          text: "<b>A product built for customer-facing teams</b><br>Explore monday sales CRM for exclusive capabilities and integrations",
          buttonText: "Visit monday sales CRM"
        }
      }
    },
    {
      tabLabel: "Construction",
      tabContent: {
        asset: {
          image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case/Marketing.png",
          }
        },
        images: [
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "Stay connected on the go",
              body: "Organize tasks, communicate with your team, and keep projects on schedule from the palm of your hand with monday.com iOS and Android app."
            })
          },
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "Track construction projects at every stage",
              body: "Streamline the office-field communication, and monitor the progress of projects in real time."
            })
          },
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "See the full picture",
              body: "Keep track of construction projects at a glance using automatically updating dashboards, and high-level overviews."
            })
          }
        ]
      }
    },
    {
      tabLabel: "HR",
      tabContent: {
        asset: {
          image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/use_case/Marketing.png",
          }
        },
        images: [
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "Recruitment workflow overview",
              body: "View the entire hiring process in a high-level dashboard, from candidate to hire."
            })
          },
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "Centralize employee information",
              body: "Manage and collaborate on HR documents from resumes to contracts and in one place."
            })
          },
          {
            src: null,
            fullParagraph: getParagraphProps({
              title: "High-level overview",
              body: "Keep track of requests per department, request types, and more, to improve your workflow."
            })
          }
        ]
      }
    }
  ]
};
